export default __webpack_public_path__ + "static/media/editIcon.f88c3747.svg";